import { Avatar, Card, Dialog, List, ListItem, ListItemAvatar, ListItemButton, ListItemText, Typography } from '@mui/material'
import HeaderGestorConfigs from '../../../../utils/headerGestorConfigs'
import { useParams } from 'react-router-dom'
import { useEffect, useState } from 'react'
import api from '../../../../services/api'
import AddAnalistaRevisor from './addAnalistaRevisor'
import AnalisePh from './analises/analisePh'
import AnaliseDissolucao from './analises/analiseDissolucao'
import AnaliseInspeccaoVisualFisica from './analises/analiseInspeccaoVisualFisica'
import AnaliseCromatografia from './analises/analiseCromatografia'
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import DeleteAnalise from './analises/deleteAnalise'


export default function AvaliacaoAnalitica({ produto, refresh, setRefresh, solicitacaoAnalise, avaliacaoAnalitica, setAvaliacaoAnalitica }) {
  // const navegate = useNavigate()
  const { produtoId } = useParams()
  const { id } = useParams()
  const [modal, setModal] = useState(false);

  const handleClose = () => { setModal(false); }

  useEffect(() => {
    api.get(`/avalicao-analiticas?productoId=${produtoId}`)
      .then(response => {
        // console.log(response);
        setAvaliacaoAnalitica(response.data.avaliacaoAnaliticas[0]);
      }).catch(err => {
        // console.log(err)
      })
  }, [produtoId, refresh, modal])

  return (
    <>
      {avaliacaoAnalitica &&
        <>
          <Card style={{ padding: 15, marginTop: 20 }}>
            <HeaderGestorConfigs title={'Avalição Analitica'} />

            <DeleteAnalise url={'/avalicao-analitica/delete'} id={avaliacaoAnalitica?._id} />

            <List sx={{ width: '100%' }}>
              <ListItem >
                {/* <ListItemAvatar>
                  <Avatar src={avaliacaoAnalitica?.analista?.dadosPessoais?.fotoURL} style={{ marginRight: 5 }} />
                </ListItemAvatar> */}
                <ListItemText primary={avaliacaoAnalitica?.analista?.dadosPessoais?.nome} secondary={'Analista'} />
              </ListItem>

              <ListItem >
                {/* <ListItemAvatar>
                  <Avatar src={avaliacaoAnalitica?.revisor?.dadosPessoais?.fotoURL} style={{ marginRight: 5 }} />
                </ListItemAvatar> */}
                <ListItemText primary={avaliacaoAnalitica?.analista?.dadosPessoais?.nome} secondary={'Revisor'} />
              </ListItem>

            </List>

            <Typography m><b>Tipos de análises a se fazer:</b></Typography>

            {(solicitacaoAnalise?.resultado !== "Aprovado" && solicitacaoAnalise?.status === "Análise da Amostra") &&
              <List component="div">
                <ListItemButton onClick={() => setModal('Análise de Inspecção Física e visual')} >
                  Análise de Inspecção Física e visual
                  {avaliacaoAnalitica?.inspeccaoVisualFisica?.resultado && <CheckBoxIcon color='secondary' />}
                </ListItemButton>

                <ListItemButton onClick={() => setModal('Análise de Cromatografia em Camada Fina')} >
                  Análise de Cromatografia em Camada Fina
                  {avaliacaoAnalitica?.cromatografia?.resultado && <CheckBoxIcon color='secondary' />}
                </ListItemButton>

                <ListItemButton onClick={() => setModal('Análise de PH')} >
                  Análise de PH
                  {avaliacaoAnalitica?.testesPH?.length > 0 && <><CheckBoxIcon color='secondary' /> {avaliacaoAnalitica?.testesPH?.length} </>}
                </ListItemButton>

                <ListItemButton onClick={() => setModal('Análise de Dissolução')} >
                  Análise de Dissolução
                  {avaliacaoAnalitica?.testesDissolucao?.length > 0 && <><CheckBoxIcon color='secondary' /> {avaliacaoAnalitica?.testesDissolucao?.length} </>}
                </ListItemButton>
              </List>
            }
          </Card>


          {/* ABRIR MODAL DE FORMULARIOS DE ANALISES */}
          <Dialog
            maxWidth={'md'}
            open={!!modal}
            // TransitionComponent={Transition}
            // keepMounted
            // onClose={handleClose}
            aria-describedby="alert-dialog-slide-description"
            scroll='body'
          >
            {/* <DialogTitle>{modal?.nome}</DialogTitle> */}

            {modal === 'Análise de Inspecção Física e visual' &&
              <AnaliseInspeccaoVisualFisica avaliacaoId={avaliacaoAnalitica?._id} ficha={false} handleClose={handleClose} />
            }
            {modal === 'Análise de Cromatografia em Camada Fina' &&
              <AnaliseCromatografia avaliacaoId={avaliacaoAnalitica?._id} ficha={false} handleClose={handleClose} />
            }
            {modal === 'Análise de PH' &&
              <AnalisePh avaliacaoId={avaliacaoAnalitica?._id} ficha={false} handleClose={handleClose} />
            }
            {modal === 'Análise de Dissolução' &&
              <AnaliseDissolucao avaliacaoId={avaliacaoAnalitica?._id} ficha={false} handleClose={handleClose} />
            }
          </Dialog>
        </>
      }

      {/* VERIFICAR MELHOR ESTA CONDICAO */}
      {solicitacaoAnalise?.status === "Chefe de Área" &&
        <AddAnalistaRevisor
          solicitacaoAnaliseId={id}
          productoId={produtoId}
          setRefresh={setRefresh}
        />
      }

      {avaliacaoAnalitica?.inspeccaoVisualFisica?.resultado &&
        <AnaliseInspeccaoVisualFisica avaliacaoId={avaliacaoAnalitica?._id} ficha={true} analises={avaliacaoAnalitica?.inspeccaoVisualFisica} />
      }

      {avaliacaoAnalitica?.cromatografia?.resultado &&
        <AnaliseCromatografia avaliacaoId={avaliacaoAnalitica?._id} ficha={true} analises={avaliacaoAnalitica?.cromatografia} />
      }

      {avaliacaoAnalitica?.testesPH?.length > 0 &&
        <AnalisePh avaliacaoId={avaliacaoAnalitica?._id} ficha={true} analises={avaliacaoAnalitica?.testesPH} />
      }

      {avaliacaoAnalitica?.testesDissolucao?.length > 0 &&
        <AnaliseDissolucao avaliacaoId={avaliacaoAnalitica?._id} ficha={true} analises={avaliacaoAnalitica?.testesDissolucao} />
      }
    </>
  )
}